
import React from "react";
import { i18nManager } from "../../i18n";
import * as ReactRouterDom from "react-router-dom";

export type BreadcrumbProps = {
    breadCrumbs: { label: string; location: string; }[];
};

function Breadcrumb(props: BreadcrumbProps) {
    const { platform } = ReactRouterDom.useParams();

    return (<div className="bread-crumb">
        <div><a href={`/${platform}`}>{i18nManager.Labels.common.rivtn_support_center}</a></div>
        {props.breadCrumbs.map((breadCrumb) => <div key={breadCrumb.label}><i className="fa fa-arrow-right"/> <a key={breadCrumb.location} href={breadCrumb.location}>{breadCrumb.label}</a></div>)}
    </div>);
}

export default Breadcrumb;
